export const CONSTANTS = {
    mode: {
        cart: "CART",
        wishlist: "WISHLIST"
    }
};
